
import { mapGetters, mapActions } from "vuex";
import { isEqual } from "lodash";
import useProductMixin from "~/mixins/useProductMixin";
import googleAnalyticsEvents from "~/mixins/googleAnalyticsEvents";
import useEvents from "~/mixins/useEvents";
import { getProductImages } from "~/utils";

export default {
  name: "ProductListCarouselCardHorizontal",
  mixins: [useProductMixin, googleAnalyticsEvents, useEvents],
  props: {
    product: {
      type: Object,
      required: true,
    },
    productIndex: {
      type: Number,
      default: 0,
    },
    statisticItemListName: {
      type: String,
      default: "",
    },
    statisticItemListId: {
      type: String,
      default: "",
    },
    isCardDrawer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getWishList: "wishlist/getWishList",
    }),
    productData() {
      return this.product;
    },
    productImage() {
      const images = getProductImages(this.product);
      return images?.[0]?.url || "";
    },
    isInWishlist() {
      return this.getWishList.some((el) =>
        isEqual(
          {
            sku: el.sku,
            engraving: el.engraving,
          },
          { engraving: {}, sku: this.productSKU }
        )
      );
    },
  },
  methods: {
    ...mapActions({
      updateWishlist: "wishlist/updateWishlist",
    }),
    onWishlist() {
      const wishlistData = {
        sku: this.productSKU,
        images: this.productImage ? [this.productImage] : [],
        cost: this.productPrice,
        slug: this.product.slug,
        configuration_id: this.productSKU,
        engraving: {},
        translations: this.product.translations,
        product_id: this.product.id,
        vendor_model: this.product.vendor_model || "",
      };
      this.updateWishlist(wishlistData);
      this.addToWishlistEvent({
        product_id: this.product.id,
        configuration_id: this.productSKU,
        product_sku: this.product.vendor_model,
        product_price: this.productPrice,
      });
    },
    sendStatistic() {
      this.gaSelectItemEvent(this.product, {
        index: this.productIndex,
        item_list_name: this.statisticItemListName,
        item_list_id: this.statisticItemListId,
      });
    },
    sendStatisticAndClose() {
      this.sendStatistic();
      if (this.isCardDrawer) {
        this.$store.commit("general/CLOSE_CART_DRAWER");
      }
    },
  },
};
